const HOCKEY_PLAYER_FIELDS = [
  {
    id: 'gamesCount',
    title: 'Сыграно игр',
  },
  {
    id: 'gamesQualifiedForPlayoff',
    title: 'Игр в зачет плей-офф',
  },
  {
    id: 'wonGamesCount',
    title: 'Побед',
  },
  {
    id: 'totalGoals',
    title: 'Голы',
  },
  {
    id: 'assists',
    title: 'Передачи'
  },
  {
    id: 'points',
    title: 'Очки'
  },
  {
    id: 'penaltyMinutes',
    title: 'Штрафные минуты'
  },
  {
    id: 'shotsOnGoal',
    title: 'Броски в створ'
  },
  {
    id: 'totalShots',
    title: 'Всего бросков'
  },
  {
    id: 'ppGoals',
    title: 'Голы в больш.'
  },
  {
    id: 'shGoals',
    title: 'Голы в меньш.'
  },
  {
    id: 'blockShots',
    title: 'Блок. броски'
  },
  {
    id: 'totalGoalsPercent',
    title: '% реализации',
    percent: true
  },
  {
    id: 'faceOffPercent',
    title: '% выигр. вбрасыв.',
    percent: true
  }
];

const HOCKEY_GOALTENDER_FIELDS = [
  {
    id: 'gamesCount',
    title: 'Сыграно игр',
  },
  {
    id: 'gamesQualifiedForPlayoff',
    title: 'Игр в зачет плей-офф',
  },
  {
    id: 'wonGamesCount',
    title: 'Побед',
  },
  {
    id: 'shutout',
    title: 'Игр отыгранных на 0',
  },
  {
    id: 'totalShotsAgainst',
    title: 'Броски соперника'
  },
  {
    id: 'shGoalsAgainst',
    title: 'Шайб пропущено в меньшинстве'
  },
  {
    id: 'ppGoalsAgainst',
    title: 'Шайб пропущено в большинстве'
  },
  {
    id: 'totalGoalsAgainst',
    title: 'Шайб пропущено'
  },
  {
    id: 'shSaves',
    title: 'Сейвы в меньшинстве'
  },
  {
    id: 'totalSaves',
    title: 'Сейвы'
  },
  {
    id: 'totalSavesPercent',
    title: '% сейвов',
    percent: true
  },
  {
    id: 'shootoutSaves',
    title: 'Отраженные буллиты'
  },
  {
    id: 'shootoutGoalsAgainst',
    title: 'Пропущенные буллиты'
  },
  {
    id: 'shootoutSavesPercent',
    title: '% отражения буллитов',
    percent: true
  },
  {
    id: 'userMinutes',
    title: 'мин'
  },
  {
    id: 'plusMinus',
    title: '+-'
  }
];

export function getHockeyStatisticHeader(goalie: boolean) {
  return goalie ? HOCKEY_GOALTENDER_FIELDS : HOCKEY_PLAYER_FIELDS;
}
